exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".multiselect__placeholder{padding-left:10px}.currency-grid{text-align:center;display:grid;grid-template-columns:1fr 1fr;grid-auto-rows:-webkit-min-content;grid-auto-rows:min-content;grid-gap:.5rem}.currency-tag{background-color:#eee;padding:.25rem .5rem;display:inline-block}", ""]);

// exports
